import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { motion } from "framer-motion";

function dncpolicy() {

  return (
    
    <div>
      <Header />
       <main>
     <section
    className="gj hj i pg"
    style={{
      marginTop: "80px", // if your header is 80px height
      backgroundImage: "url('images/privac.jpg')",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
    }}
  >
   
  </section>

     <section className="i ji">
       {/* Bg Shapes */}
      <span className="rc h s r vd fd/5 fh rm"></span>
      <img src="/images/shape-08.svg" alt="Shape Bg" className="h q r" />

      {/* Section Title */}
      <div className="animate_top bb ze rj ki xn vq">
        <motion.section
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.8 }}
      ><h2 className="fk vj pr kk wm on/5 gq/2 bb _b">
     DNC Policy
        </h2></motion.section>
      </div>
      <br/>
   <div className="bb uigy5 jutfy">
      <h2 className="ek yj mk gb">1. Purpose</h2>
      <p className="mb-4 pdt1">
        This Do Not Call (DNC) Policy outlines our commitment to respecting customer privacy and complying with applicable telemarketing and communication regulations.
      </p>
      
    </div>
     <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">2. Scope</h2>
      <p className="mb-4 ">
        This policy applies to all outbound sales, marketing, promotional, and service-related calls made by Pinakinedge Media Pvt. Ltd., including calls made on our behalf by third-party vendors.
      </p>
     
    </div>


       <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">3. Definition</h2>
      <p className="mb-4 ">
       DNC is categorized in below mentioned condition.
       <br/>
 <ul className="stjust">
          <li><b>	Client DNC/Suppression List</b> is the suppression list provided by client.</li>
          <li><b>Campaign DNC/Suppression List </b>is the suppression list for a particular campaign.</li>
          <li><b>Pause Period </b>is the time frame to attempt another call/contact after the lead is scored on prospect for a same campaign.</li>
          <li><b>	Global DNC </b>is the list of prospects where we shouldn't be calling/contacting for any client or campaign.</li>
          <li><b>Segment DNC</b> is contact list of the prospects who are not interested in services offered across any client or campaign.</li>
          <li><b>	DSAR</b> data subject removal requests will be marked as global DNC. This will be considered as a prospect DNC across all clients/campaigns. and cannot be contacted by E-mail, newsletters, and tele-calling.</li>
        </ul>
      </p>
    </div>
 <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">4. Retention Policy</h2>
      <p className="mb-4 ">
        <ul className="stjust">
          <li><b>	Client DNC</b> list and contact number would be removed from database after 1 Year or as per requirement by client. Sales team must provide updated Client DNC/Suppression at the time of onboarding the new client.</li>
          <li><b>		Campaign DNC</b> contacts will be removed from Campaign DNC database after 6 months or after the campaign closure whichever comes earlier.</li>
          <li><b>		Pause period</b> on prospect marked as Lead for the same campaign is 6 months or after the campaign closure and for another campaign the same prospect can be dialled after 15 days.</li>
          <li><b>		Global DNC </b>contacts will be removed after 1 year. Post this period, numbers can be dialled with consent of the prospect.</li>
     <li>	<b>	Segment DNC </b>contacts will be evaluated once in a year and can be removed after approval from CISO, DPO and CTO.</li>
       <li><b>		DSAR</b> removal requests will be permanent and cannot be removed.</li>
       <li>	IT Team and Quality team would require request by written and must approved by head of Sales, if there is any exception and removal request of DNC list or contact from database before retention policy mentioned above.</li>
        </ul>
      </p>
    </div>

        <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">5. DNC Registry Compliance</h2>
      <p className="mb-4 "> We comply with:
       <br/>
      
        <ul>
          <li>•	National Do Not Call (NDNC) / DNC registries</li>
          <li>•	Applicable telecom and consumer protection laws</li>
          
        </ul>
         <p className="mb-4 pdt1">  We do not place unsolicited commercial calls to phone numbers registered on official DNC lists, unless an exemption applies.</p>
      </p>
    </div>
     <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">6. Customer Opt-Out Rights</h2>
      <p className="mb-4 ">
     Customers may request to stop receiving calls at any time by:
      <br/>
      </p>
        <p className="mb-4 ">
          
          <ul>
            <li>•	Informing our representative during a call</li>
            <li>•	Emailing us at info@pinakinedgemedia.com</li>
            <li>•	Submitting a request via our website or customer portal</li>
          </ul>
        </p>
      <p className="mb-4 pdt1">
       Once a request is received, the number will be added to our internal DNC list.
     </p> 
    </div>

      <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">7. Internal DNC List</h2>
      <p className="mb-4 ">
      <ul>
            <li>•	Opt-out requests are processed within 7–30 business days (as per applicable regulations)</li>
            <li>•	Numbers on our internal DNC list will not be contacted for promotional purposes</li>
            <li>•	The opt-out remains valid unless the customer provides renewed consent</li>
          </ul>
      </p>
    </div>

       <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">8. Exceptions</h2>
      <p className="mb-4 ">
    Calls may still be made if:
      </p>
     <p className="mb-4 ">We ensure:
      <ul>
        <li>
          •	The customer has given explicit written or recorded consent</li>
<li>•	There is an existing business relationship (where permitted by law)  </li>
<li>•	The call is related to service updates, transactional, or regulatory communication  </li>
      </ul>
     </p>
     <p className="mb-4 pdt1">
      We provide transparency on:
      <br/>
      <ul>
        <li>
          •	The nature and purpose of data collection, </li>
 <li>•	Retention periods, and </li>
 <li>•	Third-party data sharing (if applicable).

        </li>
      </ul>
     </p>
    </div>
 <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">9. Third-Party Compliance</h2>
      <p className="mb-4 ">
  All third-party vendors or partners making calls on our behalf must:
      </p>
     <p className="mb-4 ">
      <ul>
        <li>
       •	Adhere to this DNC Policy
        </li>
        <li>•	Maintain updated DNC records</li>
        <li>•	Follow applicable local and international telemarketing laws
</li>
      </ul>
     </p>
     
    </div>

       <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">10. Training & Monitoring</h2>
      <p className="mb-4 ">
        We provide regular training to employees and partners on DNC compliance and monitor calling practices to ensure adherence.
      </p>
    </div>

       <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">11. Policy Violations</h2>
      <p className="mb-4 ">
      Any violation of this DNC Policy may result in disciplinary action, termination of contracts, or legal consequences.
      </p>
    </div>
 <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">12. Policy Updates</h2>
      <p className="mb-4 ">
      This policy may be updated periodically to reflect regulatory changes or operational requirements. Updates will be published on our website.
      </p>
    </div>

 <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">13. Contact Information</h2>
      <p className="mb-4 ">
       For DNC requests or questions, contact:
      </p>
       <p className="mb-4 pdt1">
        <ul>
          <li>📧 <b>Email:</b> info@pinakinedgemedia.com</li>
          <li>🏢 <b>Company:</b> Pinakinedge Media Pvt. Ltd.</li>
        </ul>
       </p>
    </div>
    </section>
  
   <br/>
    </main>
      <Footer />
    </div>
  );
}

export default dncpolicy;
